/**
 * THIS IS THE ENTRY POINT FOR THE CLIENT, JUST LIKE server.js IS THE ENTRY POINT FOR THE SERVER.
 */
import "@babel/polyfill";
import React from "react";
import { createRoot } from "react-dom/client";
import axios from "axios";
import { I18nProvider } from "@lingui/react";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import createMiddleware from "./redux/middleware/clientMiddleware";
import { i18n } from "./i18n";
import ApiClient from "./api/ApiClient";
import { rootSaga } from "./redux/sagas";
import Root from "./root";
import { persistedReducer } from "./persistConfig";
import UserService from "./utils/keycloak/UserService";

const client = new ApiClient();
const sagaMiddleware = createSagaMiddleware();

const middleware = [
  createMiddleware(client),
  sagaMiddleware,
];

// Set default baseUrl for axios
axios.defaults.baseURL = "/api";

let store;

if (__DEVELOPMENT__ && __CLIENT__ && __DEVTOOLS__) {
  /* eslint-disable no-underscore-dangle */
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  /* eslint-enable */
  store = createStore(
    persistedReducer,
    composeEnhancers(applyMiddleware(...middleware))
  );
} else {
  store = createStore(
    persistedReducer,
    compose(applyMiddleware(...middleware))
  );
}

sagaMiddleware.run(rootSaga);

const content = document.getElementById("content");

if (process.env.NODE_ENV !== "production") {
  window.React = React; // enable debugger
}

export { store };

const persistor = persistStore(store);

// Wrapping the App in a renderApp constant
// to be used as a parameter for Keycloak init method
// UserService.initKeycloak(...)
// The server only renders the HTML shell (#content is empty), so render rather
// than hydrate.
const renderApp = () =>
  createRoot(content).render(
    <I18nProvider i18n={i18n}>
      <Provider store={store} key="provider">
        <PersistGate loading={null} persistor={persistor}>
          <Root />
        </PersistGate>
      </Provider>
    </I18nProvider>
  );
// calling keycloak init
UserService.initKeycloak(renderApp);
